import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OneMonthFreeMode, OneMonthFreeStep} from "../../one-month-free.component";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {PaymentInfoComponent} from "../../../../payment-info/payment-info.component";
import {FormControl} from "@angular/forms";
import {DbValidators} from "../../../../../validators/DbValidators";
import {CouponCode} from "../../../../../../workspace/billing/coupon";
import {AuthService} from "../../../../../../auth/auth.service";
import {first} from "rxjs/operators";
import {CouponCodeMapper} from "../../../../../../workspace/billing/coupon-mapper";
import {Config} from "../../../../../../config/config";
import {User} from "../../../../../../user/user";
import {CookieService} from "ngx-cookie";
import {Utils} from "../../../../../utils/utils";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";

@Component({
    selector: 'db-one-month-free-checkout',
    templateUrl: './one-month-free-checkout.component.html',
    styleUrls: ['./one-month-free-checkout.component.scss'],
    standalone: false
})
export class OneMonthFreeCheckoutComponent implements OnInit {

  @ViewChild(PaymentInfoComponent) paymentInfo: PaymentInfoComponent;
  @Input() mode: OneMonthFreeMode;
  @Input() isAgency: boolean = false;
  @Input() isInvited: boolean = false;
  @Input() userSubscription: UserSubscription;
  @Input() user: User;
  @Input() chosenPlan: ChosenPlan;
  @Input() expirationDate: string;
  @Input() couponCode: string;
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();
  @Output() onClose = new EventEmitter<void | 'upgraded'>();
  public loading = false;
  public couponLoading = false;
  public couponSectionToggled = false;
  public couponCodeInput = new FormControl('', [DbValidators.trim]);
  public coupon: CouponCode;
  public newPrice: number = 0;
  public Config = Config;
  public demoUser: boolean = false;
  public payPalInvalidCoupons = Config.couponsList.slice(1);
  public isPaypal = false;
  public annuallyPaymentDate = new Date();
  public monthlyPaymentDate = new Date();
  public isMobile = window.innerWidth <= 991;
  public points: string[] = [
    'Free for 7 days, cancel any time',
    'We’ll remind you 24 hours before the period ends'
  ];

  constructor(
    private readonly _authService: AuthService,
    private readonly _cookieService: CookieService
  ) {
  }

  ngOnInit() {
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);

    if (!this.couponCode) {
      if (localStorage.getItem('dbCouponFromEmail')) {
        this.couponCode = localStorage.getItem('dbCouponFromEmail');
      }
      else if (this.userSubscription.trialClient) {
        this.couponCode = '1wf';
      }
    }
    if (!!this.couponCode) {

      if (this.couponCode !== '1wf' &&
        (!localStorage.getItem('dbCouponFromEmail') ||
        (localStorage.getItem('dbCouponFromEmail') && this.couponCode !== localStorage.getItem('dbCouponFromEmail')))) {
        this.couponSectionToggled = true;
        this.couponCodeInput.setValue(this.couponCode);
      }
      this.applyCoupon(this.couponCode);
    }
    this._getAnnuallyPaymentDate();
  }

  public deleteCoupon(reset = true) {
    this.couponCodeInput.reset();
    if (reset) {
      this.newPrice = 0;
      const coupon = localStorage.getItem('dbCouponFromEmail') || '1wf';
      this.applyCoupon(coupon);
    }
  }

  public applyCoupon(autoApply?): void {
    const coupon = autoApply ? autoApply : this.couponCodeInput.value;
    this.couponLoading = true;
    this._authService.applyCoupon(this.chosenPlan.id, coupon, "")
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.couponLoading = false;
        if (coupon.indexOf(Config.popupCouponPrefixForAutoApply) > -1 || !!response?.data?.free_days_before_payment) {
          this.couponCode = coupon;
          this.couponCodeInput.setErrors(null);
          this.coupon = CouponCodeMapper.map(response.data);
          this.newPrice = response.data && response.data.new_price;
        }
        else {
          this.deleteCoupon(false);
          this.couponCodeInput.setErrors({'invalidCode': true});
          return;
        }
      });
  }

  public changeSubscrId(): void {
    localStorage.setItem('dbCheckoutSubscriptionId', this.chosenPlan.id.toString());
  }

  public handlePaymentIsPaypal(isPaypal: boolean) {
    this.isPaypal = isPaypal;
  }

  private _getAnnuallyPaymentDate(): void {
    const today = new Date();
    this.annuallyPaymentDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + 7);
    this.monthlyPaymentDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 7);
  }

}
